import SmoothScroll from "../components/site/SmoothScroll";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import Ribbon from "../components/site/Ribbon";
import Stats from "../components/site/Stats";
import Manifesto from "../components/site/Manifesto";
import Showcase from "../components/site/Showcase";
import Amenities from "../components/site/Amenities";
import Community from "../components/site/Community";
import Residences from "../components/site/Residences";
import Lifestyle from "../components/site/Lifestyle";
import Location from "../components/site/Location";
import Enquiry from "../components/site/Enquiry";
import Footer from "../components/site/Footer";
import ChatBot from "../components/site/ChatBot";

export default function Home() {
  return (
    <SmoothScroll>
      <div className="grain relative bg-[#050505] min-h-screen">
        <Navbar />
        <main>
          <Hero />
          <Ribbon />
          <Stats />
          <Manifesto />
          <Showcase />
          <Community />
          <Amenities />
          <Residences />
          <Lifestyle />
          <Location />
          <Enquiry />
        </main>
        <Footer />
      </div>
      <ChatBot />
    </SmoothScroll>
  );
}
